import type MailboxInfo from 'owa-client-types/lib/MailboxInfo';
import { isMessageFileMailboxInfo } from 'owa-client-types/lib/MessageFileMailboxInfo';
import { isPstFileMailboxInfo } from 'owa-client-types/lib/PstFileMailboxInfo';
import { isUnifiedInboxMailboxInfo } from 'owa-client-types/lib/UnifiedInboxMailboxInfo';

// Do NOT use this function unless importing serviceRequestCapability from owa-capabilities-definitions
// in your package leads to a circular dependency (e.g. your code is in owa-service, owa-ows-gateway)
export function isServiceRequestSupportedForMailbox(mailboxInfo?: MailboxInfo): boolean {
    // PST and MSG files don't support service requests - these data files are local
    // and don't have an associated user/mailbox entity in the service
    // Unified inbox is a virtual mailbox that aggregates multiple accounts, so it doesn't support service requests
    return !(
        isPstFileMailboxInfo(mailboxInfo) ||
        isUnifiedInboxMailboxInfo(mailboxInfo) ||
        isMessageFileMailboxInfo(mailboxInfo)
    );
}
